import { Button, Center, Stack, Text, useMantineColorScheme, useMatches } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { TextSerif } from "@/components/elements/TextSerif";
import { IconPlus } from "@/components/icons";

import type { FC } from "react";

interface Props {
  onAddCar: (() => void) | undefined;
}

const PerformanceChartEmptyState: FC<Props> = ({ onAddCar }) => {
  const { t } = useTranslation();

  /* Theme */
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";

  const isMobile = useMatches({ base: true, md: false });

  // Garage context shows the "add car" CTA; all other contexts show a generic
  // "no data available" message without any action.
  const isGarageContext = !!onAddCar;

  return (
    <Center
      pos="absolute"
      top={0}
      right={0}
      left={0}
      bottom={isMobile ? 60 : 240}
      style={{ zIndex: 1 }}
    >
      <Stack gap="md" ta="center">
        <Stack gap="sm">
          <Text fz="h3">{isGarageContext ? t("garage.yourGarage") : t("car.valuation")}</Text>
          <TextSerif fz="sm" c={isDark ? "#999999" : "#6A6A84"}>
            {isGarageContext ? t("garage.noCarsYet") : t("car.no_data_available")}
          </TextSerif>
        </Stack>

        {isGarageContext && onAddCar && (
          <Button
            variant="filled"
            onClick={onAddCar}
            aria-label={t("dashboard.cars.create_button")}
            leftSection={<IconPlus />}
          >
            {t("dashboard.cars.create_button")}
          </Button>
        )}
      </Stack>
    </Center>
  );
};

export default PerformanceChartEmptyState;
